export enum VersionStatusEnum {
  FORCAR = 'FORÇAR',
  RECOMENDAR = 'RECOMENDAR',
  INDIFERENTE = 'INDIFERENTE',
}
